<template>
	<div class="min-h-screen bg-gray-100">
		<!-- Top Navigation Bar -->
		<AdminNavigation />

		<!-- Main Content -->
		<div v-if="canAccessDashboard">
			<div class="py-6">
				<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
					<RouterView />
				</div>
			</div>
		</div>
		<div v-else>
			<p>You are not authorized to access this page.</p>
		</div>
	</div>
</template>

<script setup>
import { computed } from "vue";
import { useAuthStore } from "@/stores/auth";
import AdminNavigation from "@/components/layout/AdminNavigation.vue";

const authStore = useAuthStore();

const canAccessDashboard = computed(() => authStore.isModerator);

const isAdmin = computed(() => authStore.isAdmin);
</script>
